import _ from 'lodash';

import { getCommonFields } from '_/components/Dashboard/Widgets/DashboardWidgets.commonFields.js';

export const getFields = (ItemStatsWidget) => {
    const commonFields = getCommonFields(ItemStatsWidget);

    const fields = [
        ...commonFields,

        {
            id: ItemStatsWidget.widget.id + '|refresh_interval',
            inline: false,
            label: 'Data Refresh Interval',
            mutation: 'widget/UPDATE_WIDGET_PROPERTY',
            name: ItemStatsWidget.widget.id + '|refresh_interval',
            disabled: true,
            optionsData: [
                {
                    id: 10 * 60 * 1000,
                    text: 'Every 10 minutes',
                },
            ],
            relatedTableName: false,
            required: true,
            tooltip: 'Widget data refresh interval.',
            value: '600000',
            vueComponent: 'Relationship',
        },
    ];

    return fields;
};
